import styled from '@emotion/styled';
import { RichTextStyle } from '../RichText';

const NavContainer = styled.div<{ hasBadge?: boolean }>`
  width: 100%;

  ${p => p.hasBadge && 'padding-top: 2.25rem;'}
`;

const Nav = styled.nav<{ textStyle: RichTextStyle }>`
  margin-bottom: ${({ theme }) => theme.spacing[10]};
  gap: ${({ theme }) => theme.spacing[20]};
  padding: ${({ theme }) =>
    `${theme.spacing[10]} ${theme.spacing[70]} ${theme.spacing[10]} ${theme.spacing[10]}`};
  margin-left: -${({ theme }) => theme.spacing[10]};
  display: flex;
  flex-wrap: wrap;
`;

export { Nav, NavContainer };
